import * as React from 'react';
import { cn } from '@/lib/utils';

export type CrowdVariant = 'cheering' | 'listening';

const SRC: Record<CrowdVariant, string> = {
  cheering:  '/character-system/poses/crowd-88-cheering-v1.png',
  listening: '/character-system/poses/crowd-88-listening-v1.png',
};

const ALT: Record<CrowdVariant, string> = {
  cheering:  'A crowd of three cheering Builders',
  listening: 'A crowd of three Builders listening',
};

export interface CrowdProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant: CrowdVariant;
  alt?: string;
}

/**
 * The Crowd — generic chorus characters. Race bibs 88, 89, 90 in ink only.
 * Used in groups; appears with no accent color.
 */
export const Crowd = React.forwardRef<HTMLImageElement, CrowdProps>(
  ({ variant, alt, className, ...rest }, ref) => (
    <img
      ref={ref}
      src={SRC[variant]}
      alt={alt ?? ALT[variant]}
      className={cn('block select-none', className)}
      draggable={false}
      {...rest}
    />
  ),
);
Crowd.displayName = 'Crowd';
